import { useFeaturesContext } from "../context/ContextProvider";
import { IState } from "../context/featuresReducer";
import { Patch, RevegetationArea, Tree } from "../lib/types";
import { downloadFile, exportShapefile } from "./requests";

interface IProps {
  setExporting: any;
  setExportError: any;
}

function useExportFeatures({ setExporting, setExportError }: IProps) {
  const state: IState = useFeaturesContext();

  const exportToShapefile = () => {
    const handleError = (e: any) => {
      console.error(e);
      setExportError(true);
      setExporting(false);
    };
    setExporting(true);
    setExportError(false);
    const patches = state.patchesList.map((x) => state.features[x] as Patch);
    const trees = state.treesList.map((x) => state.features[x] as Tree);
    const revegAreas = state.revegetationAreasList.map(
      (x) => state.features[x] as RevegetationArea
    );
    exportShapefile(patches, trees, revegAreas)
      .then((result: any) => {
        try {
          const url = result.results[0].value.url;
          downloadFile(url, url.split("/").slice(-1)[0])
            .then(() => {
              setExportError(false);
              setExporting(false);
            })
            .catch((e) => {
              handleError(e);
            });
        } catch (e) {
          handleError(e);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  };

  return exportToShapefile;
}

export default useExportFeatures;
